import {createThemedStyles} from '@/theme';

export const styles = createThemedStyles(() => ({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
}));
